module.exports = {"141029100":"昌宁镇","141029101":"光华镇","141029102":"台头镇","141029103":"管头镇","141029104":"西坡镇","141029200":"双鹤乡","141029201":"关王庙乡","141029202":"尉庄乡","141029203":"西交口乡","141029204":"枣岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141029.json
// module id = 458
// module chunks = 0